export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8847.b1c25432.jpg";